import { AllergyIntolerance } from "@medplum/fhirtypes";
import { FhirBundleSdk, Smart } from "@metriport/fhir-sdk";
import { ISO_DATE } from "@metriport/shared/common/date";
import dayjs from "dayjs";

export type AllergyRowData = {
  id: string;
  allergy: string;
  manifestation: string;
  firstSeen: string;
  originalData: Smart<AllergyIntolerance>;
};

export function getAllergyRows({ bundle }: { bundle: FhirBundleSdk }): AllergyRowData[] {
  const allergies = bundle.getAllergyIntolerances();
  return allergies
    .map(allergy => ({
      id: allergy.id ?? "-",
      allergy: allergy.reaction?.[0]?.substance?.text || allergy.code?.text || "-",
      manifestation: allergy.reaction?.[0]?.manifestation?.[0]?.text || "-",
      firstSeen: formatDate(
        allergy.onsetDateTime || allergy.onsetPeriod?.start || allergy.recordedDate
      ),
      originalData: allergy,
    }))
    .sort((a, b) => {
      const dateA = dayjs(a.firstSeen);
      const dateB = dayjs(b.firstSeen);
      const isDateAValid = dateA.isValid();
      const isDateBValid = dateB.isValid();

      if (!isDateAValid && !isDateBValid) return 0;
      if (!isDateAValid) return 1;
      if (!isDateBValid) return -1;

      return dateB.diff(dateA); // newest first
    });
}

function formatDate(date: string | undefined): string {
  if (!date || date === "-") return "-";
  try {
    const parsed = dayjs(date);
    if (!parsed.isValid()) return "-";
    return parsed.format(ISO_DATE);
  } catch {
    return "-";
  }
}
